/* eslint-disable @typescript-eslint/no-explicit-any */

import { type EnvironmentMode, type IMessagingClient, MessagingClient } from "@agoda/messaging-client";
import polyfills from "@agoda/messaging-client/dist/messaging-client-polyfills.js?url";
import workerURL from "@agoda/messaging-client/dist/messaging-client-worker.js?url";

const environment = navigator.userAgent.startsWith("Node.js") ? "development" : "prod";
const config = {
    apiKey: "fenha",
    mode: environment === "prod" ? "production" : ("development" as EnvironmentMode),
    workerUrl: "xxx",
    polyfillsUrl: "xxx",
    context: {
        sessionId: "",
    },
    fakeMode: false,
};

if (navigator.userAgent.startsWith("Node.js")) {
    config.fakeMode = true;
} else {
    config.workerUrl = workerURL;
    config.polyfillsUrl = polyfills;
}

export const messagingClient: IMessagingClient = MessagingClient.instantiate(config);
